import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNewLogoWhite = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M0 8C0 3.58172 3.58172 0 8 0H56C60.4183 0 64 3.58172 64 8V56C64 60.4183 60.4183 64 56 64H8C3.58172 64 0 60.4183 0 56V8Z",
		fill: "#105ED5"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14 16.016C14 14.9026 14.9026 14 16.016 14H48C49.1046 14 50 14.8954 50 16V47.984C50 49.0974 49.0974 50 47.984 50C29.2152 50 14 34.7848 14 16.016Z",
		fill: "#FDFEFF"
	})]
});
export { SvgNewLogoWhite as ReactComponent };
